// extracted by mini-css-extract-plugin
export default {"right_box":"index_right_box_VqAIO","stock_box":"index_stock_box_TdS5N","adBox":"index_adBox_Jsb28"};